import { IMemberDetails } from '@types';
import { FC } from 'react';
import { MemberInfo } from './MemberInfo';

type Props = {
  memberDetails: IMemberDetails;
};

export const MemberProfile: FC<Props> = ({ memberDetails }) => {
  return (
    <>
      <MemberInfo memberDetails={memberDetails} />
    </>
  );
};
